import { render } from "./FileUpload.vue?vue&type=template&id=0018e1b9&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=0018e1b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0018e1b9"

export default script